export default __webpack_public_path__ + "fonts/regencyscriptflf-webfont.woff2";